// Kulkutavan valinta. Lihasvoimaiset ja siirtymät ovat omissa ryhmissään,
// jotta käyttäjä näkee heti, mikä kerryttää peliä (suunnitelman kohta 3).

import { MODES } from "../lib/modes.js";
import { Sheet } from "./Sheet.jsx";

export function ModePicker({ title, hint, current, onPick, onClose, extra = null }) {
  const group = (eligible) => MODES.filter((m) => m.eligible === eligible);
  const option = (m) => (
    <button
      key={m.id}
      class={`mode-opt ${m.eligible ? "" : "transfer"}`}
      role="radio"
      aria-checked={current === m.id}
      onClick={() => onPick(m.id)}
    >
      {m.label}
    </button>
  );

  return (
    <Sheet title={title} onClose={onClose}>
      {hint && <p class="hint">{hint}</p>}
      {extra}
      <div class="mode-section" id="mode-eligible">Kerää ruutuja ja palkintoja</div>
      <div class="mode-grid" role="radiogroup" aria-labelledby="mode-eligible">{group(true).map(option)}</div>
      <div class="mode-section" id="mode-transfer">Siirtymä, ei kerrytä peliä</div>
      <div class="mode-grid" role="radiogroup" aria-labelledby="mode-transfer">{group(false).map(option)}</div>
      <div class="sheet-actions">
        <button class="btn btn-quiet" onClick={onClose}>Peruuta</button>
      </div>
    </Sheet>
  );
}
